import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Button,
  IconButton
} from "@material-ui/core/";
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import UserStore from "../stores/UserStore";
import withSnack from "./withSnack";
import extract_user from '../functions/extract'
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  primary: {
    color: theme.palette.secondary.light
  },
  name:{
    color: '#696969',
    fontSize: 17,
    marginBottom: 0
  },
  user:{
    color: '#9e9e9e',
    fontSize: 15,
    marginBottom: 0
  },
  caption:{
    marginTop: 25,
    fontSize: 14,
    color: '#606060'
  },
  saveButton:{
    paddingTop: 20,
    paddingBottom: 20,
    textAlign: 'center'
  }
});

class TempProfileModal extends React.Component {
constructor(props){
  super(props);
  this.state={
    title: this.props.profile.name.title,
    job_title: this.props.profile.job_title
  };
}

  onClose = (op) => {
    if (op === 'cancel'){
      this.props.onClose(null, null, 'cancel');
    }
    else{
      this.props.onClose(this.state.title, this.state.job_title, 'success');
    }

  };

  saveProfile = () => {
    UserStore.update_temp_profile(this.props.user_id, this.props.profile.id, this.state.title, this.state.job_title).then(r => {
        this.onClose();
    })
    .catch((error) => {
        this.props.snack('Error al actualizar el perfil del destinatario', 'warning')
    })
  }

  disabledSave = () => {
    const { job_title, title } = this.state;
    return (
      title === "" ||
      job_title === "" ||
      job_title === "SIN PUESTO ESPECÍFICO"
    );
  };


  onChangeProfile = (value, field) => {
    this.setState({ [field]:  value})
  }

  render() {
    const { open, classes, profile } = this.props;
    const { title, job_title } = this.state;
    let placeholder = '';
    if (job_title === 'SIN PUESTO ESPECÍFICO' || job_title === '' || job_title === undefined ){
        placeholder = job_title;
    }

    return (
      <Dialog
        aria-labelledby="Profile"
        open={open}
        maxWidth="sm"
        >
        <DialogTitle style={{textAlign: 'center'}}>Perfil del destinatario <IconButton onClick={() => this.onClose('cancel')} className="close_fix_button" >
          <CloseIcon/>
        </IconButton></DialogTitle>
        <DialogContent>
          <Typography component="span" variant="subtitle2" gutterBottom align="center" className={classes.name}>{profile.name.full}</Typography>
          <Typography variant="subtitle2" gutterBottom align="center" className={classes.user}>{extract_user(profile.email)}</Typography>
          <Typography  variant="caption" gutterBottom align="left" className={classes.caption}>Favor de llenar los campos con su información:</Typography>
          <Grid container spacing={8} direction="row" alignItems="center">
            <Grid item xl={4} lg={4} sm={4} xs={12}>
              <TextField
                placeholder="ej. C., Lic."
                margin="normal"
                label="Titulo"
                fullWidth
                value={title}
                onChange={ e => { this.onChangeProfile(e.target.value, "title"); }}
                >
              </TextField>
            </Grid>
            <Grid item xl={1} lg={1} sm={1} xs={false}/>
            <Grid item xl={7} lg={7} sm={7} xs={12}>
              <TextField
                margin="normal"
                label="Puesto"
                placeholder="ej. Jefe del Departamento de R.H."
                fullWidth
                value={placeholder !== '' ? '' : job_title}
                onChange={ e => { this.onChangeProfile(e.target.value, "job_title"); }}
                >
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
          <DialogActions>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center">
              <Grid item className={classes.saveButton}>
                <Button color="primary" variant="contained" onClick={this.saveProfile} disabled={this.disabledSave()}>
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
      </Dialog>
    );
  }
}

TempProfileModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default withStyles(styles)(withSnack(TempProfileModal))



// WEBPACK FOOTER //
// ./src/components/TempProfileModal.js